import React, { useEffect, useMemo } from "react";
import MdaeCheckBox from "../../common_components/common_widgets/check-box";
import MdaeDateBox from "../../common_components/common_widgets/date-box";
import MdaeTextArea from "../../common_components/common_widgets/text-area";
import { Validator } from "devextreme-react";
import { CustomRule, RequiredRule } from "devextreme-react/validator";
import { callOperation, actions } from "async-ops";
import MdaeSelectBox from "../../common_components/common_widgets/select-box";
import MdaePopup, {
  MdaePopupTitle,
  MdaePopupContent,
  MdaePopupFooter,
  MdaePopupFooterEndButtons,
} from "../../common_components/common_widgets/popup";
import MdaeButton from "../../common_components/common_widgets/button";
import {
  defaultUserTaskFormData,
  formatUserTaskObjectToSave,
  RESET_ADD_NEW_TASK_POPUP_VALIDATION,
  SET_ASSIGNED_USER_TYPE,
  SET_CURRENT_SELECTED_GROUP_ROW_DATA,
  SET_POPUP_OPENED_FROM_COMPLETED_BY,
  SET_REF_TASK_LIST_DATASOURCE,
  SET_SELECT_GROUP_DATAGRID_INSTANCE,
  SET_USER_TASK_DATASOURCE_VALUES,
  SET_USER_TASK_FORM_DATA,
  SET_USER_TASK_POPUP_MODE,
  SET_USER_TASK_POPUP_OPENED_FROM_CARD_VIEW,
  SET_USER_TASK_SELECTED_INDEX,
  TOGGLE_ADD_USER_TASK_POPUP,
  TOGGLE_ASSIGNED_TO_WIDGET,
  TOGGLE_COMPLETE_TASK_TOAST,
  TOGGLE_SELECT_EXTERNAL_USER_POPUP,
} from "./reducers/user-task-list-reducer";
import { SAVE_USER_TASK } from "./services/save-user-task";
import { useSelector, useDispatch } from "react-redux";
import MdaeNumericBox from "../../common_components/common_widgets/numeric-box";
import { isEmpty, isEqual } from "lodash";
import { format } from "date-fns";
import MdaeTabPanel from "../../common_components/common_widgets/tab-panel";
import { toggleUserTaskPopup, USER_TASK_POPUP_MODE } from "./component";
import {
  HIDE_LOADER,
  SHOW_LOADER,
  TOGGLE_NOTIFY_POPUP,
} from "../../common_components/mdae-common-reducer";
import mdaeNotify, {
  NOTIFY_MESSAGE_TYPE,
} from "../../common_components/common_widgets/toast/notify";
import { GET_USER_TASK_DATASOURCE } from "./services/get-user-task-datasource";
import { Item } from "devextreme-react/tab-panel";
import DocumentManagement from "../../common_components/document-management";
import {
  hasAnyFeatureGroupAccess,
  FG_AUDIT_A_CASE,
  FG_AUDIT_VIEWER,
  FG_ALL_AUDIT_VIEWER,
  FG_AUDIT_PROPERTY_EDITING,
  getUserPermissionObject,
} from "../../common_components/user-permissions-helper";
import { NOTIFY_POPUP_TYPES } from "../common_widgets/notify-popup";
import { SET_REFRESH_AUDIT_SUMMARY_DATA } from "../../pages/external-audit/reducers/external-audit-reducer";
import { GET_ATTACHMENT_LEVEL_LIST } from "./services/get-attachment-level-list";
import { bindActionCreators } from "redux";
import { SET_IS_STOP_DOCUMENT_POLLING } from "../document-management/reducers/document-management-reducer";
import { GET_USER_TASK_LIST_BY_LEVEL } from "./services/get-user-task-list-by-level";
import { GET_USER_TASK_BY_ID } from "./services/get-user-task-by-id";
import SelectExternalUser from "../select-external-user";
import $ from "jquery";
import { TOGGLE_COMPLETE_TASK_TOAST_FOR_CARD_VIEW } from "../user-task-card-view/reducers/user-task-card-view-reducer";
import SelectAssignedGroupUser from "../select-assigned-user";
import { GET_TASK_GROUP_LIST_WITH_ASSOCIATION } from "./services/get-task-group-list-with-association";
import { GET_EXTERNAL_USER_GROUP_LIST_WITH_ASSOCIATION } from "./services/get-external-user-group-list-with-association";
import { USER_TYPE } from "./constant";
import { toggleSelectAssignedGroupUserPopup } from "../select-assigned-user/component";
import { formatMMDDYYYY_HHMM, formatUSLocaleDate,  } from "../../utils/dateUtils";
import { getUserPreference, setUserPreference } from "../../utils/commom-utils";
import { LabelWithCopyText, ToggleLabelWithCopyText } from "../common-task-case-header/component";
import { SEND_USER_TASK_REMINDER } from "./services/send-user-task-reminder";
import { useTaskCommonFunctions } from "./hooks/use-task-common-functions";
import TaskHistoryPopup, { toggleTaskHistoryPopup } from "./task-history-popup";

export const IsMRNToggleEnabled = "IsMRNToggleEnabled";
export const IsAcctNoToggleEnabled = "IsAcctNoToggleEnabled";

export const TASK_DISPLAY_MODES = {
  TASK_POPUP: "TaskPopup",
  CASE_POPUP: "CasePopup",
};
export type TaskDisplayMode = (typeof TASK_DISPLAY_MODES)[keyof typeof TASK_DISPLAY_MODES];


export const openUserTaskInEditMode = (
  currentSelectedRowData,
  toggleUserTaskPopup,
  userTaskSelectedIndex,
  dispatch,
  isFromUserTaskList = true,
  isOpenedFromCardView = false,
  displayMode: TaskDisplayMode = TASK_DISPLAY_MODES.TASK_POPUP
) => {
  dispatch({
    type: SET_USER_TASK_FORM_DATA,
    data: {
      userTaskFormData: {
        ...defaultUserTaskFormData,
      },
    },
  });
  if (displayMode === TASK_DISPLAY_MODES.TASK_POPUP) {
    toggleUserTaskPopup(
      dispatch,
      true,
      currentSelectedRowData.refTaskName +
        " - " +
        currentSelectedRowData.levelName,
      USER_TASK_POPUP_MODE.EDIT,
    );
  }
  dispatch({ type: SHOW_LOADER });
  let returnPromise = callOperation(GET_USER_TASK_BY_ID, currentSelectedRowData.userTaskId).then(
    function(response) {
      var taskData = response.userTaskData[0];
      var initialTaskData = {
        statusId: response.userTaskData[0].statusId,
        assignedToUserId: response.userTaskData[0].assignedToUserId,
        externalNotes: response.userTaskData[0].externalNotes,
        notificationId: 0,
      };
      taskData.auditGroupId = currentSelectedRowData.auditGroupId;
      dispatch({
        type: SET_USER_TASK_FORM_DATA,
        data: {
          userTaskFormData: {
            ...taskData,
            completeIndBeforeEdit: taskData.completeInd,
            auditId: currentSelectedRowData?.auditId,
          },
          initialTaskData: initialTaskData,
        },
      });
      dispatch({
        type: SET_USER_TASK_SELECTED_INDEX,
        data: { userTaskSelectedIndex: userTaskSelectedIndex },
      });
      dispatch({
        type: SET_ASSIGNED_USER_TYPE,
        data: {
          assignedUserType: taskData?.assignedUserType,
        },
      });
      callOperation(GET_USER_TASK_DATASOURCE, {
        attachedLevelId: currentSelectedRowData.userTaskId,
        attachedLevelName: currentSelectedRowData.attachedLevel,
        attachedLevel: currentSelectedRowData.attachedLevel,
      }).then((response) => {
        dispatch({
          type: SET_USER_TASK_DATASOURCE_VALUES,
          data: {
            userLevelNameList: response.userLevelNameList,
            userTaskListFiltered: response.userTaskList,
            refTaskList: response.refTaskList,
            assignedToUserList: response.assignedToUserList,
          },
        });
        dispatch({
          type: SET_REF_TASK_LIST_DATASOURCE,
          data: { userTaskFormData: currentSelectedRowData },
        });
        dispatch({ type: HIDE_LOADER });
      });
      if (!isFromUserTaskList) {
        dispatch(actions.asyncOperationStart(GET_ATTACHMENT_LEVEL_LIST, {}));
      }
      setTimeout(() => {
        window.dispatchEvent(
          new CustomEvent("resize", { detail: { isResizeMdaePopup: true } })
        );
      }, 0);
    }
  );
  dispatch({
    type: SET_USER_TASK_POPUP_MODE,
    userTaskPopupMode: USER_TASK_POPUP_MODE.EDIT,
  });
  dispatch({
    type: SET_USER_TASK_POPUP_OPENED_FROM_CARD_VIEW,
    data: {
      isOpenedFromCardView: isOpenedFromCardView,
    },
  });
  return returnPromise;
};
export const getTaskItem = (arrayOfTaskItem) => {
  return arrayOfTaskItem.map((x) => <li>{x}</li>);
};
export const toggleSelectExternalUserPopup = (dispatch, isVisible) => {
  dispatch({
    type: TOGGLE_SELECT_EXTERNAL_USER_POPUP,
    data: {
      isSelectExternalUserPopupVisible: isVisible,
    },
  });
};

export const showNewTasksCreatedPopup = (
  dispatch,
  isExternalUser,
  response,
  assignedToUserId
) => {
  let assignedToExternalUser = [];
  let newTaskCreated = [];
  if (response.newUserTasks && response.newUserTasks.length > 0) {
    for (var item of response.newUserTasks) {
      if (item.userTaskId) {
        response.newUserTasksCreated.push(item);
      }
    }
  }
  if (isExternalUser && response.newUserTasksCreated?.length > 0) {
    assignedToExternalUser = response.newUserTasksCreated.filter(
      (x) => x.assignedToUserId == assignedToUserId
    );
    newTaskCreated = assignedToExternalUser;
  } else {
    newTaskCreated = response.newUserTasksCreated;
  }
  if (newTaskCreated && newTaskCreated.length > 0) {
    var displayMessage = "";
    var arrayOfTaskItem = [];
    for (var item of newTaskCreated) {
      displayMessage =
        " " +
        item.refTaskName +
        ", " +
        "Assigned To: " +
        item.assignedToUserName +
        ", Due " +
        new Date(item.dueDate)?.toLocaleDateString();
      arrayOfTaskItem.push(displayMessage);
    }
    dispatch({
      type: TOGGLE_NOTIFY_POPUP,
      data: {
        visible: true,
        contentHtml: () => {
          return (
            <div>
              <div style={{ display: "block" }}>
                New task(s) were created as a result of updating this task and
                have been configured based on the process template.{" "}
              </div>
              <div>
                <ul>{getTaskItem(arrayOfTaskItem)}</ul>
              </div>
            </div>
          );
        },
        notifyPopupType: NOTIFY_POPUP_TYPES.ALERT,
        closeButtonText: "OK",
        width: 470,
        height: "auto",
      },
    });
  }
};

export const saveUserTask = (
  isClosePopup,
  userTaskFormData,
  currentAttachedLevelId,
  currentAttachedLevelName,
  userTaskPopupMode,
  userLevelNameList,
  dispatch,
  asyncAction,
  props: IAddUserTaskPopup,
  includeNonAttachedLevelTasks,
  initialTaskData,
  isOpenedFromCardView = false,
  isCancelUpdatedTask,
  displayMode: TaskDisplayMode = TASK_DISPLAY_MODES.TASK_POPUP
) => {
  dispatch({ type: SHOW_LOADER });
  const dataToSave = formatUserTaskObjectToSave(
    userTaskFormData,
    currentAttachedLevelId,
    currentAttachedLevelName,
    userTaskPopupMode,
    userLevelNameList
  );
  dataToSave.auditId = userTaskFormData?.auditId;
  if (props?.isExternalUser) {
    dataToSave.isSavedFromExternalUser = true;
  }
  return callOperation(SAVE_USER_TASK, {
    ...dataToSave,
    eaRoundId: props.eaRoundId,
  }).then(function(response) {
    dispatch({ type: HIDE_LOADER });
    if (response.isSaved) {
      if (props.isFromUserTaskList) {
        if (typeof props.refreshUserTaskListFunction === "function")
          props.refreshUserTaskListFunction();
        else if (!props.isManagerView) {
            asyncAction.asyncOperationStart(GET_USER_TASK_LIST_BY_LEVEL, {
              attachedLevelId: props.attachedLevelId,
              attachedLevelName: props.attachedLevelName,
              includeNonAttachedLevelTasks: includeNonAttachedLevelTasks,
            });
        }
      }

      if (props.isRefreshExternalAuditSummaryData) {
        dispatch({
          type: SET_REFRESH_AUDIT_SUMMARY_DATA,
          data: true,
        });
      }
      if (!props?.isExternalUser) {
        mdaeNotify({
          message: userTaskFormData.refTaskName + " - task saved successfully.",
          messageType: NOTIFY_MESSAGE_TYPE.SUCCESS,
        });
      } else if (!isCancelUpdatedTask && dataToSave.completeInd) {
        if (!isOpenedFromCardView) {
          dispatch({
            type: TOGGLE_COMPLETE_TASK_TOAST,
            data: {
              isCompleteTaskToastVisible: true,
            },
          });
        } else {
          dispatch({
            type: TOGGLE_COMPLETE_TASK_TOAST_FOR_CARD_VIEW,
            data: {
              isCompleteTaskToastVisibleForCardView: true,
            },
          });
        }
      } else if (!isCancelUpdatedTask) {
        mdaeNotify({
          message: userTaskFormData.refTaskName + " - task saved successfully.",
          messageType: NOTIFY_MESSAGE_TYPE.SUCCESS,
        });
      }
      if (!isClosePopup) {
        openUserTaskInEditMode(
          {
            ...response.userTaskData,
            auditGroupId: userTaskFormData?.auditGroupId,
          },
          toggleUserTaskPopup,
          0,
          dispatch
        );
      }
      if (props.attachedLevelName == "EA")
        props.refreshCaseListFromDb(dispatch, props.attachedLevelId);
    } else {
      mdaeNotify({
        message: "Unable to save task",
        messageType: NOTIFY_MESSAGE_TYPE.ERROR,
      });
    }
    showNewTasksCreatedPopup(
      dispatch,
      props.isExternalUser,
      response,
      userTaskFormData.assignedToUserId
    );
    dispatch({
      type: SET_USER_TASK_FORM_DATA,
      data: {
        initialTaskData: {
          ...initialTaskData,
          notificationId: response.notificationId,
          newUserTasksCreatedIds: response.newUserTasksCreated?.map(
            (x) => x.userTaskId
          ),
        },
      },
    });
    if (isClosePopup && displayMode === TASK_DISPLAY_MODES.TASK_POPUP) toggleUserTaskPopup(dispatch, false, "", null);
    else window.dispatchEvent(new Event("resize"));
  });
};
export const validateAndsaveUserTask = (params, isClosePopup, props, asyncAction, displayMode = TASK_DISPLAY_MODES.TASK_POPUP) => {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      const state = getState();
      const {
        userTaskFormData,
        attachLevelEnums,
        currentAttachedLevelId,
        currentAttachedLevelName,
        userTaskPopupMode,
        userLevelNameList,
        includeNonAttachedLevelTasks,
        initialTaskData,
        isOpenedFromCardView,
      } = state.userTaskListReducer;

      let result = null;
      if (!userTaskFormData.scheduledDate && userTaskFormData.scheduleTime) {
        dispatch({
          type: TOGGLE_NOTIFY_POPUP,
          data: {
            visible: true,
            contentHtml: () => {
              return (
                <div>
                  A rescheduled date is required when a scheduled time is added.
                </div>
              );
            },
            notifyPopupType: NOTIFY_POPUP_TYPES.ERROR,
            closeButtonText: "OK",
            width: 470,
            height: 220,
          },
        });
        resolve(false);
        return;
      }
      if (
        (userTaskFormData.completedByUsedId || userTaskFormData.completionDate) &&
        !userTaskFormData.completeInd
      ) {
        dispatch({
          type: TOGGLE_NOTIFY_POPUP,
          data: {
            visible: true,
            contentHtml: () => {
              return <div>You need to check completed task checkbox</div>;
            },
            notifyPopupType: NOTIFY_POPUP_TYPES.ERROR,
            closeButtonText: "OK",
            width: 470,
            height: 220,
          },
        });
        resolve(false);
        return;
      }
      if (params.validationGroup) result = params.validationGroup.validate();
      if (result && result.isValid) {
        let savePromise;
        if (props.isExternalUser) {
          dispatch({
            type: SET_USER_TASK_POPUP_OPENED_FROM_CARD_VIEW,
            data: {
              isMaintenanceLevelTask: isMaintenanceTask(
                userTaskFormData,
                attachLevelEnums
              ),
            },
          });
          savePromise = saveUserTask(
            isClosePopup,
            userTaskFormData,
            currentAttachedLevelId,
            currentAttachedLevelName,
            userTaskPopupMode,
            userLevelNameList,
            dispatch,
            asyncAction, 
            props,
            includeNonAttachedLevelTasks,
            initialTaskData,
            isOpenedFromCardView,
            false,
            displayMode
          );
          toggleUserTaskPopup(dispatch, false, "", null);
        } else {
          savePromise = saveUserTask(
            isClosePopup,
            userTaskFormData,
            currentAttachedLevelId,
            currentAttachedLevelName,
            userTaskPopupMode,
            userLevelNameList,
            dispatch,
            asyncAction, 
            props,
            includeNonAttachedLevelTasks,
            initialTaskData,
            false,
            false,
            displayMode
          );
        }
        if (savePromise && typeof savePromise.then === "function") {
          savePromise.then(resolve).catch(reject);
        } else {
          resolve(true);
        }
      } else {
        resolve(false);
      }
    });
  };
};
export const isMaintenanceTask = (userTaskFormData, attachLevelEnums) => {
  const attachedLevel = userTaskFormData?.attachedLevel;
  if (attachedLevel) {
    const maintenanceTaskAttachedLevels = [
      attachLevelEnums.provider,
      attachLevelEnums.renderingProviderGroup,
      attachLevelEnums.coder,
      attachLevelEnums.coderGroup,
      attachLevelEnums.facility,
    ];
    return maintenanceTaskAttachedLevels.includes(attachedLevel.toUpperCase());
  }
  return false;
};

interface IAddUserTaskPopup {
  attachedLevelName?: string;
  isExternalUser?: boolean;
  isManagerView: boolean;
  isFromUserTaskList?: boolean;
  isRefreshExternalAuditSummaryData?: boolean;
  auditGroupId?: number;
  eaRoundId?: number;
  attachedLevelId?: number;
  isFromMyTaskPage: boolean;
  toggleUserTaskPopup: (dispatch, isVisible, title?, mode?) => void;
  refreshUserTaskListFunction?: () => void;
  refreshCaseListFromDb?: (dispatch, auditId, updateRoundData?) => void;
}
const AddUserTaskPopup: React.FC<IAddUserTaskPopup> = (props) => {
  const dispatch = useDispatch();
  const UserTaskValidationGroup = "UserTaskValidationGroup";
  const { getAssignedUserList, onUserTaskStatusChanged } = useTaskCommonFunctions();
  const userTaskFormData = useSelector(
    (state: any) => state["userTaskListReducer"].userTaskFormData,
    isEqual
  );
  const currentUser = useSelector(
    (state) => state["mdaeNavigationBarReducer"].currentUser,
    isEqual
  );
  const qaReviewPermission = getUserPermissionObject(
    "ALL_AUDITS_FOR_QA_REVIEW||MY_AUDITS_FOR_QA_REVIEW",
    currentUser
  );
  const taskGroupPermission = getUserPermissionObject(
    "TASK_GROUPS",
    currentUser
  );

  const userTaskPopupMode = useSelector(
    (state: any) => state["userTaskListReducer"].userTaskPopupMode,
    isEqual
  );
  const userTaskStatusList = useSelector(
    (state: any) => state["userTaskListReducer"].userTaskStatusList,
    isEqual
  );
  const refTaskList = useSelector(
    (state: any) => state["userTaskListReducer"].refTaskList,
    isEqual
  );
  const defaultStatusValue = useSelector(
    (state: any) => state["userTaskListReducer"].defaultStatusValue,
    isEqual
  );
  const completedStatusValue = useSelector(
    (state: any) => state["userTaskListReducer"].completedStatusValue,
    isEqual
  );

  const attachLevelEnums = useSelector(
    (state: any) => state["userTaskListReducer"].attachLevelEnums,
    isEqual
  );
  const currentUserId = useSelector(
    (state: any) => state["userTaskListReducer"].currentUserId,
    isEqual
  );

  const currentAttachedLevelName = useSelector(
    (state) => state["userTaskListReducer"].currentAttachedLevelName,
    isEqual
  );

  const isAddUserTaskPopupVisible = useSelector(
    (state) => state["userTaskListReducer"].isAddUserTaskPopupVisible,
    isEqual
  );
  const userTaskPopupTitle = useSelector(
    (state) => state["userTaskListReducer"].userTaskPopupTitle,
    isEqual
  );

  const isDocumentManagementEnabled = useSelector(
    (state) => state["documentManagementReducer"].isDocumentManagementEnabled,
    isEqual
  );
  const processManagerId = useSelector(
    (state) =>
      state["auditPropertiesReducer"].auditPropertiesData?.processManagerId,
    isEqual
  );

  const isSelectExternalUserPopupVisible = useSelector(
    (state: any) => state.userTaskListReducer.isSelectExternalUserPopupVisible,
    isEqual
  );

  const isBulkEditUserTaskPopupVisible = useSelector(
    (state: any) => state.userTaskListReducer.isBulkEditUserTaskPopupVisible,
    isEqual
  );
  let userLevelNameList = useSelector(
    (state) => state["userTaskListReducer"].userLevelNameList,
    isEqual
  );
  const isTaskHistoryPopupVisible = useSelector(
    (state: any) => state["userTaskListReducer"].isTaskHistoryPopupVisible,
    isEqual
  );
  const isSelectAssignedGroupUserPopupVisible = useSelector(
    (state: any) =>
      state.userTaskListReducer.isSelectAssignedGroupUserPopupVisible
  );
  const assignedUserType = useSelector(
    (state: any) => state.userTaskListReducer.assignedUserType
  );
  if (userLevelNameList && userLevelNameList.length > 0) {
    if (
      props.attachedLevelName?.toUpperCase() === "EA" &&
      userTaskFormData?.level?.toUpperCase() === "EAC" &&
      userTaskPopupMode == USER_TASK_POPUP_MODE.ADD
    ) {
      const isAllExists =
        userLevelNameList.filter((x) => x.attachedLevelId === -1).length > 0;
      if (!isAllExists) {
        userLevelNameList.unshift({
          attachedLevelId: -1,
          attachedLevelTitle: "Add tasks to all cases in round",
        });
      }
    } else {
      userLevelNameList = userLevelNameList.filter(
        (x) => x.attachedLevelId > 0
      );
    }
  }

  const asyncAction = bindActionCreators(
    {
      asyncOperationStart: actions.asyncOperationStart,
    },
    dispatch
  );
  let hasEditAccess = useMemo(
    () => hasAnyFeatureGroupAccess([FG_AUDIT_PROPERTY_EDITING], currentUser),
    [currentUser]
  );
  const isSendReminderButtonVisible = hasEditAccess &&userTaskPopupMode === USER_TASK_POPUP_MODE.EDIT &&(userTaskFormData?.statusType != "Completed" && userTaskFormData?.statusType != "Canceled");
  const hasTaskManagerAccess =
    (qaReviewPermission.hasAllAuditsForQaReviewUpdateAccess &&
      qaReviewPermission.hasMyAuditsForQaReviewUpdateAccess) ||
    (currentUser?.isTaskHQAccessEnabled &&
      window.location.pathname.toLowerCase().includes("audit/taskhq"));
  const hasTaskGroupAccessOnly =
    taskGroupPermission.hasUpdateAccess &&
    !(
      qaReviewPermission.hasAllAuditsForQaReviewUpdateAccess &&
      qaReviewPermission.hasMyAuditsForQaReviewUpdateAccess
    );

  useEffect(() => {
    const fetchPreferences = async () => {
      const isMRNToggleEnabled = await getUserPreference(IsMRNToggleEnabled);
      const isAccountToggleEnabled = await getUserPreference(
        IsAcctNoToggleEnabled
      );
      if (isMRNToggleEnabled.settings === "false") {
        isMRNToggleEnabled.settings = false;
      }
      if (isAccountToggleEnabled.settings === "false") {
        isAccountToggleEnabled.settings = false;
      }
      dispatch({
        type: SET_USER_TASK_FORM_DATA,
        data: {
          userTaskFormData: {
            isMRNToggleEnabled: isMRNToggleEnabled?.settings,
            isAccountToggleEnabled: isAccountToggleEnabled?.settings,
          },
        },
      });
    };

    fetchPreferences();
  }, []);
  useEffect(() => {
    if (
      userTaskPopupMode == USER_TASK_POPUP_MODE.ADD &&
      isAddUserTaskPopupVisible
    ) {
      dispatch({
        type: SET_REF_TASK_LIST_DATASOURCE,
        data: {
          filterBy: "Level",
          currentAttachedLevelName: props.attachedLevelName,
        },
      });
    }
  }, [refTaskList]);
  useEffect(() => {
    if (defaultStatusValue && userTaskPopupMode == USER_TASK_POPUP_MODE.ADD && isAddUserTaskPopupVisible) {
      dispatch({
        type: SET_USER_TASK_FORM_DATA,
        data: {
          userTaskFormData: {
            statusId: defaultStatusValue,
          },
        },
      });
    }
  }, [defaultStatusValue,userTaskPopupMode,isAddUserTaskPopupVisible]);

  useEffect(() => {
    if ( userTaskPopupMode == USER_TASK_POPUP_MODE.ADD && isAddUserTaskPopupVisible && isEmpty(assignedUserType)) {
      dispatch({
        type: SET_USER_TASK_FORM_DATA,
        data: {
          userTaskFormData: {
            assignedUserType: USER_TYPE.NORMAL,
          },
        },
      });
    }
  }, [userTaskPopupMode,isAddUserTaskPopupVisible,assignedUserType]);

  const hasAuditViewAccess = useMemo(
    () =>
      hasAnyFeatureGroupAccess(
        [FG_AUDIT_A_CASE, FG_AUDIT_VIEWER, FG_ALL_AUDIT_VIEWER],
        currentUser
      ),
    [currentUser]
  );

  const getUserTaskPopupTitle = () => {
    const isACLevel = ["AC", "EAC"].includes(userTaskFormData?.attachedLevel);

    const patientName = `${userTaskFormData?.patientLastName}, ${userTaskFormData?.patientFirstName}`;

    const dobText = userTaskFormData?.dob
      ? formatUSLocaleDate(userTaskFormData.dob)
      : "";

    const mrnText =
      userTaskFormData?.isMRNToggleEnabled 
        ? userTaskFormData.patientAlternateMRN ||""
        : userTaskFormData?.patientMRN || "";

    const accountNumberText = userTaskFormData?.isAccountToggleEnabled
      ? userTaskFormData?.patientAcctNoOrig || ""
      : userTaskFormData?.patientAcctNo || "";

    const dosText = userTaskFormData?.statementFromDate
      ? `${formatUSLocaleDate(
          userTaskFormData.statementFromDate
        )} - ${formatUSLocaleDate(userTaskFormData.statementToDate)}`
      : "";

    return (
      <MdaePopupTitle
        className="ea-user-task-container"
        closePopupHandler={() => props.toggleUserTaskPopup(dispatch, false)}
        customTitleRender={() => (
          <div>
            {(isACLevel && userTaskPopupMode === USER_TASK_POPUP_MODE.EDIT) && (
              <div className="task-detail-popup-header vertical-split">
              {userTaskFormData?.isPtNameSelected && (
                <LabelWithCopyText
                  label="Pt. Name:"
                  value={patientName}
                  title={patientName}
                />
              )}
            
              {userTaskFormData?.isDOBSelected && (
                <LabelWithCopyText label="DOB:" value={dobText} title={dobText}/>
              )}
            
              {userTaskFormData?.isMRNSelected && (
                <ToggleLabelWithCopyText
                  toggleValue={userTaskFormData.isMRNToggleEnabled}
                  title={mrnText}
                  onToggleChange={(e) => {
                    if (e.event) {
                      dispatch({
                        type: SET_USER_TASK_FORM_DATA,
                        data: {
                          userTaskFormData: {
                            isMRNToggleEnabled: e.value,
                          },
                        },
                      });
                      setUserPreference(IsMRNToggleEnabled, e.value);
                    }
                  }}
                  labelOn="Alt MRN :"
                  labelOff="MRN :"
                  value={mrnText}
                />
              )}
              {userTaskFormData?.isAccountNumSelected && (
                <ToggleLabelWithCopyText
                  toggleValue={userTaskFormData.isAccountToggleEnabled}
                  title= {accountNumberText}
                  className={'account-extra-width'}
                  onToggleChange={(e) => {
                    if (e.event) {
                      dispatch({
                        type: SET_USER_TASK_FORM_DATA,
                        data: {
                          userTaskFormData: {
                            isAccountToggleEnabled: e.value,
                          },
                        },
                      });
                      setUserPreference(IsAcctNoToggleEnabled, e.value);
                    }
                  }}
                  labelOn="Original Acct # :"
                  labelOff="Acct # :"
                  value={accountNumberText}
                />
              )}
              {userTaskFormData?.isDOSSelected && (
                <LabelWithCopyText
                  label="DOS:"
                  value={dosText}
                  title={dosText}
                />
              )}
            </div>
            )}
          </div>
        )}
      >
        {userTaskPopupTitle}
      </MdaePopupTitle>
    );
  };

  const renderPopupComponent = useMemo(() => {
    const isUserTaskLevelVisible =
      userTaskPopupMode === USER_TASK_POPUP_MODE.ADD &&
      currentAttachedLevelName === "EA";
    const isUserTaskLevelNameVisible =
      userTaskPopupMode === USER_TASK_POPUP_MODE.ADD &&
      currentAttachedLevelName === "EA" &&
      userTaskFormData.level === "EAC";
    const isEditMode = userTaskPopupMode === USER_TASK_POPUP_MODE.EDIT;
    return (
      <div>
        <MdaeTabPanel
          id="pnlUserTaskTabPanel"
          deferRendering={false}
          className={
            hasEditAccess || hasTaskManagerAccess ? "" : "disable-popup"
          }
          mdaeDataUpdaterConfig={[
            {
              actionType: SET_USER_TASK_SELECTED_INDEX,
              reducerName: "userTaskListReducer",
              widgetOptionBindings: {
                selectedIndex: "userTaskSelectedIndex",
              },
            },
          ]}
        >
          <Item title="Properties">
            <div className={"widget-separation-margin-top"}>
              <div className={"row remove-margin"}>
                <div
                  className="col-lg-2 remove-padding"
                  style={{
                    display: isUserTaskLevelVisible ? "block" : "none",
                  }}
                >
                  <MdaeSelectBox
                    id={"ddlUserTaskLevel"}
                    width={180}
                    mdaeDropDownBoxTitle={"Level"}
                    displayExpr={"displayName"}
                    valueExpr={"value"}
                    disabled={false}
                    visible={isUserTaskLevelVisible}
                    required={true}
                    name="level"
                    value={userTaskFormData.level}
                    onValueChanged={(e) => {
                      dispatch(onValueChanged)(e)
                      if (userTaskPopupMode == USER_TASK_POPUP_MODE.ADD) {
                        dispatch({
                          type: SET_REF_TASK_LIST_DATASOURCE,
                          data: {
                            filterBy: "Level",
                            currentAttachedLevelName: currentAttachedLevelName,
                          },
                        });
                      }
                    }}
                    mdaeDataUpdaterConfig={[
                      {
                        actionType: GET_ATTACHMENT_LEVEL_LIST,
                        reducerName: "userTaskListReducer",
                        widgetOptionBindings: {
                          dataSource: "userEaTaskAttachmentLevels",
                        },
                      },
                      {
                        actionType: RESET_ADD_NEW_TASK_POPUP_VALIDATION,
                        reducerName: "userTaskListReducer",
                        widgetOptionBindings: {
                          isValid: "isAddNewTaskFormDataValid",
                        },
                      },
                    ]}
                  >
                    <Validator validationGroup={UserTaskValidationGroup}>
                      <CustomRule
                        reevaluate={true}
                        validationCallback={(options) => {
                          if (options.value || !isUserTaskLevelVisible) {
                            return true;
                          } else {
                            return false;
                          }
                        }}
                        message="Please select Level."
                      />
                    </Validator>
                  </MdaeSelectBox>
                </div>
                <div
                  className="col-lg-4 remove-padding"
                  style={{
                    display: isUserTaskLevelNameVisible ? "block" : "none",
                  }}
                >
                  {isUserTaskLevelNameVisible && (
                    <MdaeSelectBox
                      id={"ddlLevelName"}
                      mdaeDropDownBoxTitle={"Level Name"}
                      displayExpr={"attachedLevelTitle"}
                      valueExpr={"attachedLevelId"}
                      disabled={false}
                      dataSource={userLevelNameList}
                      visible={isUserTaskLevelNameVisible}
                      required={true}
                      width={380}
                      name="attachedLevelId"
                      value={userTaskFormData.attachedLevelId}
                      onValueChanged={(e) => {
                        dispatch(onValueChanged)(e);
                        if (userTaskPopupMode == USER_TASK_POPUP_MODE.ADD) {
                          dispatch({
                            type: SET_REF_TASK_LIST_DATASOURCE,
                            data: {
                              filterBy: "LevelName",
                              currentAttachedLevelName: currentAttachedLevelName,
                            },
                          });
                        }
                      }}
                      mdaeDataUpdaterConfig={[
                        {
                          actionType: RESET_ADD_NEW_TASK_POPUP_VALIDATION,
                          reducerName: "userTaskListReducer",
                          widgetOptionBindings: {
                            isValid: "isAddNewTaskFormDataValid",
                          },
                        },
                      ]}
                    >
                      <Validator validationGroup={UserTaskValidationGroup}>
                        <CustomRule
                          reevaluate={true}
                          validationCallback={(options) => {
                            if (options.value || !isUserTaskLevelNameVisible) {
                              return true;
                            } else {
                              return false;
                            }
                          }}
                          message="Please select Level Name."
                        />
                      </Validator>
                    </MdaeSelectBox>
                  )}
                </div>

                <div className="col-lg-4 remove-padding">
                  <MdaeSelectBox
                    id={"ddlTask"}
                    mdaeDropDownBoxTitle={"Task"}
                    displayExpr={"refTaskName"}
                    valueExpr={"refTaskId"}
                    readOnly={userTaskPopupMode === USER_TASK_POPUP_MODE.EDIT}
                    disabled={checkIfAssignedToGroup(assignedUserType)}
                    required={true}
                    width={390}
                    name="refTaskId"
                    value={userTaskFormData.refTaskId}
                    onValueChanged={dispatch(onValueChanged)}
                    onSelectionChanged={(e) => {
                      if (e.selectedItem) {
                        const assignedToId = e.selectedItem.assignedToUserId
                          ? e.selectedItem.assignedToUserId
                          : processManagerId;
                        const hasAssignedToUserId =
                          e.selectedItem?.hasAssignedToUserId;
                        dispatch({
                          type: SET_USER_TASK_FORM_DATA,
                          data: {
                            userTaskFormData: {
                              dueDate: e.selectedItem?.dueDate,
                              assignedToUserId: assignedToId
                                ? assignedToId
                                : currentUserId,
                              isAssignedToExternalUser:
                                e.selectedItem?.isAssignedToExternalUser,
                              assignedUserType:
                                e.selectedItem?.assignedToUserType ==
                                  USER_TYPE.EG ||
                                e.selectedItem?.assignedToUserType ==
                                  USER_TYPE.TG
                                  ? e.selectedItem?.assignedToUserType
                                  : USER_TYPE.NORMAL,
                            },
                          },
                        });
                        dispatch({
                          type: TOGGLE_ASSIGNED_TO_WIDGET,
                          data: {
                            isAssignedToDisabled:
                              !hasTaskManagerAccess &&
                              (userTaskPopupMode === USER_TASK_POPUP_MODE.EDIT
                                ? hasAssignedToUserId
                                : assignedToId)
                                ? true
                                : false,
                          },
                        });
                        if (e.selectedItem?.assignedToUserType === "EU") {
                          getAssignedUserList(
                            !props.isManagerView
                              ? props.auditGroupId
                              : userTaskFormData.auditGroupId,
                            false,
                          );
                        }
                      }
                    }}
                    mdaeDataUpdaterConfig={[
                      {
                        actionType: SET_REF_TASK_LIST_DATASOURCE,
                        reducerName: "userTaskListReducer",
                        widgetOptionBindings: {
                          dataSource: "refTaskDataSource",
                        },
                      },
                      {
                        actionType: RESET_ADD_NEW_TASK_POPUP_VALIDATION,
                        reducerName: "userTaskListReducer",
                        widgetOptionBindings: {
                          isValid: "isAddNewTaskFormDataValid",
                        },
                      },
                    ]}
                  >
                    <Validator validationGroup={UserTaskValidationGroup}>
                      <RequiredRule message="Please select Task." />
                    </Validator>
                  </MdaeSelectBox>
                </div>
                <div className="col-lg-2 remove-padding">
                  {TaskStatusComponent(
                    userTaskStatusList,
                    assignedUserType,
                    userTaskFormData,
                    hasTaskManagerAccess,
                    onUserTaskStatusChanged,
                    UserTaskValidationGroup,
                  )}
                </div>
                <div
                  className="col-lg-2 remove-padding"
                  style={{ display: isEditMode ? "block" : "none" }}
                >
                  <CompleteTaskCheckBoxComponent
                    isEditMode={isEditMode}
                    hasTaskManagerAccess={hasTaskManagerAccess}
                    width={150}
                  />
                </div>
                <div
                  className="col-lg-3 remove-padding"
                  style={{ display: isEditMode ? "block" : "none" }}
                >
                  {CompletedByComponent(
                    assignedUserType,
                    userTaskFormData,
                    hasTaskManagerAccess,
                    props.isExternalUser,
                    props.isManagerView,
                    props.auditGroupId,
                    isEditMode,
                    getAssignedUserList,
                    dispatch,
                    390,
                  )}
                </div>
              </div>
              <div className={"row remove-margin widget-separation-margin-top"}>
                <div
                  className={"col-lg-2 remove-padding"}
                  style={{ display: isEditMode ? "block" : "none" }}
                >
                  {CompletedOnComponent(
                    dispatch,
                    isEditMode,
                    assignedUserType,
                    userTaskFormData,
                    hasTaskManagerAccess,
                    props.isExternalUser,
                  )}
                </div>
                <div className={"col-lg-2 remove-padding"}>
                  {DueDateComponent(
                    dispatch,
                    assignedUserType,
                    userTaskFormData,
                    hasTaskManagerAccess,
                    props.isExternalUser,
                    UserTaskValidationGroup,
                  )}
                </div>
                <div className={"col-lg-2 remove-padding"}>
                  {AsignedToComponent(
                    props.isManagerView,
                    props.auditGroupId,
                    userTaskFormData,
                    hasTaskManagerAccess,
                    hasTaskGroupAccessOnly,
                    props.isExternalUser,
                    getAssignedUserList,
                    dispatch,
                    asyncAction,
                    UserTaskValidationGroup,
                    190
                  )}
                </div>
                <div className={"col-lg-2 remove-padding"}>
                  {RescheduledDateComponent(
                    dispatch,
                    assignedUserType,
                    userTaskFormData,
                    hasTaskManagerAccess,
                    props.isExternalUser,
                  )}
                </div>
                <div className={"col-lg-2 remove-padding"}>
                  {ScheduledTimeComponent(
                    dispatch,
                    assignedUserType,
                    userTaskFormData,
                    hasTaskManagerAccess,
                    props.isExternalUser,
                  )}
                </div>
                <div className={"col-lg-2 remove-padding"}>
                  {TotalTimeComponent(
                    dispatch,
                    assignedUserType,
                    userTaskFormData,
                    hasTaskManagerAccess,
                    props.isExternalUser,
                  )}
                </div>
              </div>
              <div className={"row remove-margin widget-separation-margin-top"}>
                <div className="col-lg-6 remove-padding">
                  {AuditorNotesComponent(
                    dispatch,
                    props.isManagerView,
                    props.isExternalUser,
                    userTaskFormData,
                    attachLevelEnums,
                    assignedUserType,
                    600
                  )}
                </div>
                <div className="col-lg-6 remove-padding">
                  {SchedulingNotesComponent(
                    dispatch,
                    userTaskFormData,
                    assignedUserType,
                    props.isExternalUser,
                    600
                  )}
                </div>
              </div>
              <div
                className={"row remove-margin widget-separation-margin-top"}
                style={{ display: "flex" }}
              >
                {!props.isExternalUser && (
                  <div
                    className="remove-padding"
                    style={{ flex: 1, marginRight: 13 }}
                  >
                    {ManagerNotesComponent(
                      assignedUserType,
                      hasTaskManagerAccess,
                      userTaskFormData,
                      dispatch,
                    )}
                  </div>
                )}
                {(userTaskFormData?.isAssignedToExternalUser ||
                  userTaskFormData?.isCompletedByExternalUser ||
                  userTaskFormData?.externalNotes) && (
                  <div
                    className="remove-padding"
                    style={{
                      flex: 1,
                      marginRight: 30,
                      marginLeft: props.isExternalUser ? 0 : 20,
                    }}
                  >
                    <MdaeTextArea
                      id={"txtUserTaskExternalNotes"}
                      mdaeTextAreaTitle={"Payer Notes"}
                      height={80}
                      maxLength={2000}
                      disabled={checkIfAssignedToGroup(assignedUserType)}
                      value={userTaskFormData?.externalNotes}
                      onValueChanged={(e) => {
                        if (e.value && e.event) {
                          dispatch({
                            type: SET_USER_TASK_FORM_DATA,
                            data: {
                              userTaskFormData: {
                                externalNotes: e.value,
                              },
                            },
                          });
                        }
                      }}
                    ></MdaeTextArea>
                  </div>
                )}
              </div>
            </div>
            <div className={"widget-separation-margin-top"}></div>
            {USER_TASK_POPUP_MODE.EDIT == userTaskPopupMode && (
              <>
                <div
                  className="col-xs-12 remove-padding"
                  style={{ marginTop: "16px", display: "flex" }}
                >
                  <div className="col-xs-6 remove-padding">
                    <div className="col-xs-12 remove-padding">
                      <div className="col-xs-4 remove-padding">
                        <div className="mdae-data-field-label">Created By:</div>
                      </div>
                      <div className="col-xs-6 remove-padding">
                        <div className="mdae-data-field-content">
                          {userTaskFormData.createdBy}
                        </div>
                      </div>
                    </div>
                    <div
                      className="col-xs-12 remove-padding"
                      style={{ marginTop: "6px" }}
                    >
                      <div className="col-xs-4 remove-padding">
                        <div className="mdae-data-field-label">Created On:</div>
                      </div>
                      <div className="col-xs-6 remove-padding">
                        <div className="mdae-data-field-content">
                          {" "}
                          {userTaskFormData.createDate
                            ? format(
                                new Date(userTaskFormData.createDate),
                                "MM/DD/YYYY",
                              )
                            : ""}
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="col-xs-6 remove-padding">
                    <div className="col-xs-12 remove-padding">
                      <div className="col-xs-4 remove-padding">
                        <div className="mdae-data-field-label">
                          Last Updated By:
                        </div>
                      </div>
                      <div className="col-xs-6 remove-padding">
                        <div className="mdae-data-field-content">
                          <div>
                            {userTaskFormData.updatedByExternalUserGroupName ===
                            "" ? (
                              userTaskFormData.updatedBy
                            ) : userTaskFormData.updatedByExternalUserGroupName?.toLowerCase() ==
                              "external" ? (
                              <span>
                                {userTaskFormData.updatedBy} (
                                <i>
                                  {
                                    userTaskFormData.updatedByExternalUserGroupName
                                  }
                                </i>
                                )
                              </span>
                            ) : (
                              userTaskFormData.updatedBy +
                              ` (` +
                              userTaskFormData.updatedByExternalUserGroupName +
                              `)`
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      className="col-xs-12 remove-padding"
                      style={{ marginTop: "6px" }}
                    >
                      <div className="col-xs-4 remove-padding">
                        <div className="mdae-data-field-label">
                          Last Updated On:
                        </div>
                      </div>
                      <div className="col-xs-6 remove-padding">
                        <div className="mdae-data-field-content">
                          {userTaskFormData.updateDate
                            ? format(
                                new Date(userTaskFormData.updateDate),
                                "MM/DD/YYYY",
                              )
                            : ""}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-xs-2 remove-padding" style={{ alignContent: 'center' }} role="button">
                    <a style={{ fontSize: '16px' }}
                      onClick={() => toggleTaskHistoryPopup(true, dispatch, userTaskFormData?.refTaskName)} 
                    >
                      Task History
                    </a>
                  </div>
                </div>
              </>
            )}
          </Item>
          <Item
            title="Document Management"
            visible={
              userTaskPopupMode === USER_TASK_POPUP_MODE.EDIT &&
              isDocumentManagementEnabled
            }
          >
            {isDocumentManagementEnabled && isAddUserTaskPopupVisible && (
              <DocumentManagement
                hasAuditViewAccess={hasAuditViewAccess}
                attachedLevelId={userTaskFormData.userTaskId}
                attachedLevelName="TS"
                showForCoderReviewInd={false}
                isManagerView={false}
                isDocumentUploadDisable={
                  userTaskFormData.isTaskLinkedWithCompletedAudit &&
                  props.isExternalUser
                }
                taskAttachmentLevel={userTaskFormData.level}
                parentAttachmentLevelName={userTaskFormData.attachedLevel}
                parentAttachmentLevelId={userTaskFormData.attachedLevelId}
              />
            )}
            
          </Item>
        </MdaeTabPanel>
      </div>
    );
  }, [
    userTaskFormData,
    userTaskPopupMode,
    currentAttachedLevelName,
    refTaskList,
    hasTaskManagerAccess,
  ]);
  const renderComponent = () => {
    return renderPopupComponent;
  };
  const handleSendReminder = async () => {
    if (!userTaskFormData) return;
    dispatch({ type: SHOW_LOADER });
    const userTaskId = userTaskFormData?.userTaskId;
    const response = await callOperation(SEND_USER_TASK_REMINDER,userTaskId);
      if (response.isReminderSent) {
        mdaeNotify({
          message:`Reminder sent to ${response.userTaskData.assignedToUserName} for task -${response.userTaskData.refTaskName}`,
          messageType: NOTIFY_MESSAGE_TYPE.SUCCESS,
        });
        dispatch({
          type: SET_USER_TASK_FORM_DATA,
          data: {
            userTaskFormData: {
              lastReminderSentDate: response.userTaskData.lastReminderSentDate,
              lastReminderSentByUserId: response.userTaskData.lastReminderSentByUserId,
              lastReminderEmailSentByUserName: response.userTaskData.lastReminderEmailSentByUserName,
            },
          },
        });
      }
      else{
        mdaeNotify({
          message:`Failed to send reminder to ${response.userTaskData.assignedToUserName} for task -${response.userTaskData.refTaskName}`,
          messageType: NOTIFY_MESSAGE_TYPE.SUCCESS,
        });
      }
      dispatch({ type: HIDE_LOADER });
  };
  return (
    <>
      {isSelectExternalUserPopupVisible && !isBulkEditUserTaskPopupVisible && (
        <SelectExternalUser
          getAssignedUserList={getAssignedUserList}
          auditGroupId={
            !props.isManagerView
              ? props.auditGroupId
              : userTaskFormData.auditGroupId
          }
        ></SelectExternalUser>
      )}
      {isSelectAssignedGroupUserPopupVisible &&
        !isBulkEditUserTaskPopupVisible && (
          <SelectAssignedGroupUser
            getAssignedUserList={getAssignedUserList}
            auditGroupId={
              !props.isManagerView
                ? props.auditGroupId
                : userTaskFormData.auditGroupId
            }
          ></SelectAssignedGroupUser>
        )}
        {isTaskHistoryPopupVisible && (
          <TaskHistoryPopup/>
        )}
      <MdaePopup
        deferRendering={false}
        width={1300}
        height='auto'
        onHidden={() => {
          dispatch({
            type: SET_IS_STOP_DOCUMENT_POLLING,
            isStopDocumentPooling: true,
          });
        }}
        id={"pnlAddUserTaskPopup"}
        visible={isAddUserTaskPopupVisible}
        mdaeTitleRender={getUserTaskPopupTitle}
        mdaeDataUpdaterConfig={[
          {
            actionType: TOGGLE_ADD_USER_TASK_POPUP,
            reducerName: "userTaskListReducer",
            widgetOptionBindings: {
              mdaePopupTitle: "userTaskPopupTitle",
            },
          },
        ]}
        mdaeContentRender={() => {
          return <MdaePopupContent>{renderComponent()}</MdaePopupContent>;
        }}
        mdaeFooterRender={() => {
          return (
            <MdaePopupFooter>
              <div style={{ display: "flex", width: "100%" }}>
                <MdaeButton
                  id={"btnCancelUserTask"}
                  role={"secondary"}
                  onClick={() => {
                    props.toggleUserTaskPopup(dispatch, false);
                  }}
                >
                  Cancel
                </MdaeButton>
                <MdaeButton
                  id={"btnSendReminderEmail"}
                  role={"secondary"}
                  onClick={handleSendReminder}
                  disabled={
                    userTaskFormData?.lastReminderSentDate &&
                    new Date(userTaskFormData.lastReminderSentDate).getTime() +
                      24 * 60 * 60 * 1000 >
                      Date.now()
                  }
                  visible={isSendReminderButtonVisible }
                >
                  Send Reminder Email
                </MdaeButton>
                {isSendReminderButtonVisible && userTaskFormData.lastReminderSentDate &&
                  userTaskFormData.lastReminderEmailSentByUserName && (
                    <div style={{ fontSize:'11px',marginTop:'10px' }}>
                      Last reminder email sent:{' '}
                      {formatMMDDYYYY_HHMM(
                        userTaskFormData.lastReminderSentDate
                      )}  by {userTaskFormData.lastReminderEmailSentByUserName}{" "}
                    </div>
                  )}
              </div>
              <MdaePopupFooterEndButtons>
                {(hasEditAccess || hasTaskManagerAccess) &&
                  !props.isExternalUser && (
                    <>
                      <MdaeButton
                        id={"btnSaveUserTask"}
                        visible={userTaskFormData.attachedLevelId !== -1}
                        validationGroup={UserTaskValidationGroup}
                        onClick={(params) => {
                          dispatch(validateAndsaveUserTask(params, false, props, asyncAction));
                        }}
                        role={"primary"}
                      >
                        Save
                      </MdaeButton>
                      <MdaeButton
                        id={"btnSaveAndCloseUserTask"}
                        validationGroup={UserTaskValidationGroup}
                        onClick={(params) => {
                          dispatch(validateAndsaveUserTask(params, true, props, asyncAction));
                        }}
                        role={"primary"}
                      >
                        Save and Close
                      </MdaeButton>
                    </>
                  )}
                {props.isExternalUser && (
                  <>
                    <MdaeButton
                      id={"btnCompleteTask"}
                      visible={userTaskFormData.attachedLevelId !== -1}
                      validationGroup={UserTaskValidationGroup}
                      disabled={checkIfAssignedToGroup(assignedUserType)}
                      onClick={(params) => {
                        userTaskFormData.completeInd = true;
                        userTaskFormData.completedByUsedId = currentUserId;
                        userTaskFormData.completionDate = new Date();
                        if (!isStatusTypeCompleted(userTaskStatusList, userTaskFormData.statusId)) {
                          userTaskFormData.statusId = completedStatusValue;
                        }
                        dispatch({
                          type: SET_USER_TASK_FORM_DATA,
                          data: { userTaskFormData: { ...userTaskFormData } },
                        });
                        dispatch(validateAndsaveUserTask(params, true, props, asyncAction));
                      }}
                      role={"primary"}
                    >
                      Complete Task
                    </MdaeButton>
                    <MdaeButton
                      id={"btnSaveAndCloseUserTask"}
                      validationGroup={UserTaskValidationGroup}
                      onClick={(params) => {
                        dispatch(validateAndsaveUserTask(params, true, props, asyncAction));
                      }}
                      role={"primary"}
                    >
                      Save and Close
                    </MdaeButton>
                  </>
                )}
              </MdaePopupFooterEndButtons>
            </MdaePopupFooter>
          );
        }}
      ></MdaePopup>
    </>
  );
};
const checkIfAssignedToGroup = (assignedUserType) => {
  if (assignedUserType == USER_TYPE.EG || assignedUserType == USER_TYPE.TG)
    return true;
  else return false;
};
export const isStatusTypeCompleted = (userTaskStatusList, statusId) => {
  return (
    userTaskStatusList
      ?.find((x) => x.statusId === statusId)
      ?.statusType?.toLowerCase() === "completed"
  );
};
interface ICompleteTaskCheckBoxComponent{
 hasTaskManagerAccess: boolean, 
 isEditMode: boolean,
 width?: any
}
export const CompleteTaskCheckBoxComponent: React.FC<ICompleteTaskCheckBoxComponent> = (
 {width = 'auto', ...props}
) => {
  const dispatch = useDispatch();
  const assignedUserType = useSelector(
    (state: any) => state.userTaskListReducer.assignedUserType,
  );
  const userTaskFormData = useSelector(
    (state: any) => state["userTaskListReducer"].userTaskFormData,
    isEqual
  );
  const currentUserId = useSelector(
    (state: any) => state["userTaskListReducer"].currentUserId,
    isEqual,
  );
  const userTaskStatusList = useSelector(
    (state: any) => state["userTaskListReducer"].userTaskStatusList,
    isEqual,
  );
  const completedStatusValue = useSelector(
    (state: any) => state["userTaskListReducer"].completedStatusValue,
    isEqual,
  );
  const defaultPreviousStatusValue = useSelector(
    (state: any) => state["userTaskListReducer"].defaultPreviousStatusValue,
    isEqual,
  );
  const onUserTaskCompletedValueChanged = (e) => {
    if (e.event) {
      let statusId = userTaskFormData.statusId;
      let completedByUsedId = userTaskFormData.completedByUsedId;
      let completionDate = userTaskFormData.completionDate;
      if (e.value || e == true) {
        completedByUsedId = currentUserId;
        completionDate = new Date();
        if (
          !isStatusTypeCompleted(userTaskStatusList, userTaskFormData.statusId)
        ) {
          statusId = completedStatusValue;
        }
      } else {
        completedByUsedId = null;
        completionDate = null;
        if (
          isStatusTypeCompleted(userTaskStatusList, userTaskFormData.statusId)
        ) {
          statusId = defaultPreviousStatusValue;
        }
      }
      dispatch({
        type: SET_USER_TASK_FORM_DATA,
        data: {
          userTaskFormData: {
            completeInd: e.value,
            statusId,
            completedByUsedId,
            completionDate,
          },
        },
      });
    }
  };
  return (
    <MdaeCheckBox
      id="chkUserTaskCheckBox"
      text="Completed Task"
      width={width}
      disabled={
        checkIfAssignedToGroup(assignedUserType) ||
        (userTaskFormData.completeIndBeforeEdit &&
          !props.hasTaskManagerAccess)
      }
      visible={props.isEditMode}
      value={userTaskFormData.completeInd}
      onValueChanged={onUserTaskCompletedValueChanged}
    />
  );
};

export default AddUserTaskPopup;
export function SchedulingNotesComponent(
  dispatch,
  userTaskFormData: any,
  assignedUserType: any,
  isExternalUser: boolean,
  width: any = 'auto'
) {
  return (
    <MdaeTextArea
      id={"txtUserTaskSchedulingNotes"}
      mdaeTextAreaTitle={"Scheduling Notes"}
      height={80}
      maxLength={1000}
      disabled={checkIfAssignedToGroup(assignedUserType)}
      width={width}
      readOnly={isExternalUser}
      name="schedulingNotes"
      value={userTaskFormData.schedulingNotes}
      onValueChanged={dispatch(onValueChanged)}
    ></MdaeTextArea>
  );
}

export function TotalTimeComponent(
  dispatch,
  assignedUserType: any,
  userTaskFormData: any,
  hasTaskManagerAccess: any,
  isExternalUser: boolean,
) {
  return (
    <MdaeNumericBox
      id={"txtTotalTime"}
      width={115}
      disabled={
        checkIfAssignedToGroup(assignedUserType) ||
        (userTaskFormData.completeIndBeforeEdit && !hasTaskManagerAccess) ||
        (isExternalUser && !hasTaskManagerAccess)
      }
      mdaeNumberBoxTitle={"Total Time (min)"}
      min={0}
      max={9999.99}
      name="totalTime"
      value={userTaskFormData.totalTime}
      onValueChanged={dispatch(onValueChanged)}
    ></MdaeNumericBox>
  );
}

export function ScheduledTimeComponent(
  dispatch,
  assignedUserType: any,
  userTaskFormData: any,
  hasTaskManagerAccess: any,
  isExternalUser: boolean,
) {
  return (
    <MdaeDateBox
      id="dtpScheduleTime"
      mdaeDateBoxTitle="Scheduled Time"
      type={"time"}
      width={180}
      disabled={
        checkIfAssignedToGroup(assignedUserType) ||
        (userTaskFormData.completeIndBeforeEdit && !hasTaskManagerAccess) ||
        (isExternalUser && !hasTaskManagerAccess)
      }
      name="scheduleTime"
      value={userTaskFormData.scheduleTime}
      onValueChanged={dispatch(onValueChanged)}
    ></MdaeDateBox>
  );
}

export function RescheduledDateComponent(
  dispatch,
  assignedUserType: any,
  userTaskFormData: any,
  hasTaskManagerAccess: any,
  isExternalUser: boolean,
) {
  return (
    <MdaeDateBox
      id="dtpRescheduleDate"
      width={180}
      disabled={
        checkIfAssignedToGroup(assignedUserType) ||
        (userTaskFormData.completeIndBeforeEdit && !hasTaskManagerAccess) ||
        (isExternalUser && !hasTaskManagerAccess)
      }
      mdaeDateBoxTitle="Rescheduled Date"
      name="scheduledDate"
      value={userTaskFormData.scheduledDate}
      onValueChanged={dispatch(onValueChanged)}
    ></MdaeDateBox>
  );
}

export function ManagerNotesComponent(
  assignedUserType: any,
  hasTaskManagerAccess: any,
  userTaskFormData: any,
  dispatch,
) {
  return (
    <MdaeTextArea
      id={"txtUserTaskManagerNotes"}
      mdaeTextAreaTitle={"Manager Notes"}
      height={80}
      maxLength={2000}
      disabled={checkIfAssignedToGroup(assignedUserType)}
      readOnly={!hasTaskManagerAccess}
      name="managerNotes"
      value={userTaskFormData?.managerNotes}
      onValueChanged={dispatch(onValueChanged)}
    ></MdaeTextArea>
  );
}

export function AuditorNotesComponent(
  dispatch,
  isManagerView: boolean,
  isExternalUser: boolean,
  userTaskFormData: any,
  attachLevelEnums: any,
  assignedUserType: any,
  width: any = 'auto'
) {
  return (
    <MdaeTextArea
      id={"txtUserTaskAuditorNotes"}
      mdaeTextAreaTitle={
        isManagerView
          ? isMaintenanceTask(userTaskFormData, attachLevelEnums)
            ? "Notes"
            : "Auditor Notes"
          : "Process Manager Notes"
      }
      readOnly={isExternalUser}
      height={80}
      width={width}
      maxLength={2000}
      disabled={checkIfAssignedToGroup(assignedUserType)}
      name="auditorNotes"
      value={userTaskFormData.auditorNotes}
      onValueChanged={dispatch(onValueChanged)}
    ></MdaeTextArea>
  );
}

export function AsignedToComponent(
  isManagerView: boolean,
  auditGroupId: number,
  userTaskFormData: any,
  hasTaskManagerAccess: any,
  hasTaskGroupAccessOnly: boolean,
  isExternalUser: boolean,
  getAssignedUserList: (auditgroupId: any, isFromAssignedToField: any) => any,
  dispatch,
  asyncAction: { asyncOperationStart: any },
  validationGroup: string,
  width: any = 'auto'
) {
  return (
    <MdaeSelectBox
      id={"ddlAssignTo"}
      mdaeDropDownBoxTitle={"Assigned To"}
      displayExpr={"fullName"}
      required={true}
      disabled={
        (userTaskFormData.completeIndBeforeEdit &&
          !hasTaskManagerAccess &&
          !hasTaskGroupAccessOnly) ||
        (userTaskFormData.createdBy?.toLowerCase() === "mdaudit" &&
          !hasTaskManagerAccess &&
          !hasTaskGroupAccessOnly) ||
        (isExternalUser && !hasTaskManagerAccess && !hasTaskGroupAccessOnly)
      }
      valueExpr={"auditUserId"}
      width={width}
      dataSource={getAssignedUserList(
        !isManagerView ? auditGroupId : userTaskFormData.auditGroupId,
        true,
      )}
      itemRender={(e) => {
        if (e?.auditUserId < 0) {
          return (
            <div className="external-user-item">
              <div>{e.fullName}</div>
            </div>
          );
        } else return <div>{e?.fullName}</div>;
      }}
      onOpened={(e) => {
        setTimeout(() => {
          $(".dx-item.dx-list-item:has(.external-user-item)").addClass(
            "external-user-border",
          );
        });
      }}
      value={userTaskFormData.assignedToUserId}
      onValueChanged={(e) => {
        if (e.value && e.event) {
          dispatch({
            type: SET_POPUP_OPENED_FROM_COMPLETED_BY,
            data: {
              isSelectUserPopupOpenedFromCompletedBy: false,
            },
          });
          if (e.value > 0) {
            dispatch({
              type: SET_USER_TASK_FORM_DATA,
              data: {
                userTaskFormData: {
                  assignedToUserId: e.value,
                  isAssignedToExternalUser: false,
                  assignedUserType: USER_TYPE.NORMAL,
                },
              },
            });
            dispatch({
              type: SET_ASSIGNED_USER_TYPE,
              data: {
                assignedUserType: USER_TYPE.NORMAL,
              },
            });
          } else if (e.value === -1) {
            dispatch({
              type: SET_ASSIGNED_USER_TYPE,
              data: {
                assignedUserType: USER_TYPE.NORMAL,
              },
            });
            toggleSelectExternalUserPopup(dispatch, true);
            dispatch({
              type: SET_USER_TASK_FORM_DATA,
              data: {
                userTaskFormData: {
                  assignedToUserId:
                    e.previousValue === null ? 0 : e.previousValue,
                  assignedUserType: USER_TYPE.NORMAL,
                },
              },
            });
          } else if (e.value === -2) {
            asyncAction.asyncOperationStart(
              GET_EXTERNAL_USER_GROUP_LIST_WITH_ASSOCIATION,
              {},
            );
            toggleSelectAssignedGroupUserPopup(dispatch, true);
            dispatch({
              type: SET_USER_TASK_FORM_DATA,
              data: {
                userTaskFormData: {
                  assignedToUserId:
                    e.previousValue === null ? 0 : e.previousValue,
                },
              },
            });
            dispatch({
              type: SET_ASSIGNED_USER_TYPE,
              data: {
                assignedUserType: USER_TYPE.EG,
              },
            });
            dispatch({
              type: SET_SELECT_GROUP_DATAGRID_INSTANCE,
              data: {
                selectGroupDataGridInstance: undefined,
              },
            });
            dispatch({
              type: SET_CURRENT_SELECTED_GROUP_ROW_DATA,
              data: {
                setCurrentSelectedGroupRowData: undefined,
              },
            });
          } else if (e.value === -3) {
            asyncAction.asyncOperationStart(
              GET_TASK_GROUP_LIST_WITH_ASSOCIATION,
              {},
            );
            toggleSelectAssignedGroupUserPopup(dispatch, true);
            dispatch({
              type: SET_USER_TASK_FORM_DATA,
              data: {
                userTaskFormData: {
                  assignedToUserId:
                    e.previousValue === null ? 0 : e.previousValue,
                },
              },
            });
            dispatch({
              type: SET_ASSIGNED_USER_TYPE,
              data: {
                assignedUserType: USER_TYPE.TG,
              },
            });
            dispatch({
              type: SET_SELECT_GROUP_DATAGRID_INSTANCE,
              data: {
                selectGroupDataGridInstance: undefined,
              },
            });
            dispatch({
              type: SET_CURRENT_SELECTED_GROUP_ROW_DATA,
              data: {
                setCurrentSelectedGroupRowData: undefined,
              },
            });
          }
        }
      }}
      mdaeDataUpdaterConfig={[
        {
          actionType: TOGGLE_ASSIGNED_TO_WIDGET,
          reducerName: "userTaskListReducer",
          widgetOptionBindings: {
            disabled: "isAssignedToDisabled",
          },
        },
      ]}
    >
      <Validator validationGroup={validationGroup}>
        <RequiredRule message="Please select Assigned To." />
      </Validator>
    </MdaeSelectBox>
  );
}

export function DueDateComponent(
  dispatch,
  assignedUserType: any,
  userTaskFormData: any,
  hasTaskManagerAccess: any,
  isExternalUser: boolean,
  validationGroup: string,
) {
  return (
    <MdaeDateBox
      id="dtpUserTaskDueDate"
      mdaeDateBoxTitle="Due Date"
      required={true}
      disabled={
        checkIfAssignedToGroup(assignedUserType) ||
        (userTaskFormData.completeIndBeforeEdit && !hasTaskManagerAccess) ||
        (userTaskFormData.createdBy?.toLowerCase() === "mdaudit" &&
          !hasTaskManagerAccess) ||
        isExternalUser
      }
      width={180}
      name="dueDate"
      value={userTaskFormData.dueDate}
      onValueChanged={dispatch(onValueChanged)}
      mdaeDataUpdaterConfig={[
        {
          actionType: RESET_ADD_NEW_TASK_POPUP_VALIDATION,
          reducerName: "userTaskListReducer",
          widgetOptionBindings: {
            isValid: "isAddNewTaskFormDataValid",
          },
        },
      ]}
    >
      <Validator validationGroup={validationGroup}>
        <RequiredRule message="Please select Due Date." />
      </Validator>
    </MdaeDateBox>
  );
}

export function CompletedOnComponent(
  dispatch,
  isEditMode: boolean,
  assignedUserType: any,
  userTaskFormData: any,
  hasTaskManagerAccess: any,
  isExternalUser: boolean,
) {
  return (
    <MdaeDateBox
      id="dtpCompletedOn"
      width={180}
      visible={isEditMode}
      disabled={
        checkIfAssignedToGroup(assignedUserType) ||
        (userTaskFormData.completeIndBeforeEdit && !hasTaskManagerAccess) ||
        isExternalUser
      }
      name="completionDate"
      value={userTaskFormData.completionDate}
      onValueChanged={dispatch(onValueChanged)}
      mdaeDateBoxTitle="Completed On"
    ></MdaeDateBox>
  );
}

export function CompletedByComponent(
  assignedUserType: any,
  userTaskFormData: any,
  hasTaskManagerAccess: any,
  isExternalUser: boolean,
  isManagerView: boolean,
  auditGroupId: number,
  isEditMode: boolean,
  getAssignedUserList: (auditgroupId: any, isFromAssignedToField: any) => any,
  dispatch,
  width: any = 'auto'
) {
  return (
    <MdaeSelectBox
      id={"ddlCompletedBy"}
      mdaeDropDownBoxTitle={"Completed By"}
      displayExpr={"fullName"}
      disabled={
        checkIfAssignedToGroup(assignedUserType) ||
        (userTaskFormData.completeIndBeforeEdit && !hasTaskManagerAccess) ||
        (isExternalUser && !hasTaskManagerAccess)
      }
      valueExpr={"auditUserId"}
      visible={isEditMode}
      dataSource={getAssignedUserList(
        !isManagerView ? auditGroupId : userTaskFormData.auditGroupId,
        false,
      )}
      value={userTaskFormData.completedByUsedId}
      itemRender={(e) => {
        if (e?.auditUserId === -1) {
          return (
            <div className="completed-by-external-user-item">
              <div>{e.fullName}</div>
            </div>
          );
        } else return <div>{e?.fullName}</div>;
      }}
      onOpened={(e) => {
        setTimeout(() => {
          $(
            ".dx-item.dx-list-item:has(.completed-by-external-user-item)",
          ).addClass("external-user-border");
        });
      }}
      onValueChanged={(e) => {
        if (e.value && e.event) {
          if (e.value !== -1) {
            dispatch({
              type: SET_USER_TASK_FORM_DATA,
              data: {
                userTaskFormData: {
                  completedByUsedId: e.value,
                  isCompletedByExternalUser: false,
                },
              },
            });
          } else if (e.value === -1) {
            dispatch({
              type: SET_POPUP_OPENED_FROM_COMPLETED_BY,
              data: {
                isSelectUserPopupOpenedFromCompletedBy: true,
              },
            });
            toggleSelectExternalUserPopup(dispatch, true);
            dispatch({
              type: SET_USER_TASK_FORM_DATA,
              data: {
                userTaskFormData: {
                  completedByUsedId:
                    e.previousValue === null ? 0 : e.previousValue,
                },
              },
            });
          }
        }
      }}
      width={width}
    ></MdaeSelectBox>
  );
}

export function TaskStatusComponent(
  userTaskStatusList: any,
  assignedUserType: any,
  userTaskFormData: any,
  hasTaskManagerAccess: any,
  onUserTaskStatusChanged: (e: any) => void,
  validationGroup: string,
) {
  return (
    <MdaeSelectBox
      id={"ddlTaskStatus"}
      mdaeDropDownBoxTitle={"Status"}
      dataSource={userTaskStatusList}
      displayExpr={"displayAlias"}
      valueExpr={"statusId"}
      disabled={
        checkIfAssignedToGroup(assignedUserType) ||
        (userTaskFormData.completeIndBeforeEdit && !hasTaskManagerAccess)
      }
      required={true}
      width={190}
      name="statusId"
      value={userTaskFormData.statusId}
      onValueChanged={onUserTaskStatusChanged}
      mdaeDataUpdaterConfig={[
        {
          actionType: RESET_ADD_NEW_TASK_POPUP_VALIDATION,
          reducerName: "userTaskListReducer",
          widgetOptionBindings: {
            isValid: "isAddNewTaskFormDataValid",
          },
        },
      ]}
    >
      <Validator validationGroup={validationGroup}>
        <RequiredRule message="Please select Task Status." />
      </Validator>
    </MdaeSelectBox>
  );
}
export const onValueChanged = (dispatch) => (e: any) => {
  if (e.event) {
    dispatch({
      type: SET_USER_TASK_FORM_DATA,
      data: {
        userTaskFormData: {
          [e.component.option("name")]: e.value,
        },
      },
    });
  }
};